import RaisedButton from 'material-ui/RaisedButton';
import { Tab, Tabs } from 'material-ui/Tabs';
import MenuItem from 'material-ui/MenuItem';
import React, { Component } from 'react';
import autoBind from 'react-autobind';
import SwipeableViews from 'react-swipeable-views';
import { Field, FieldArray, formValues, formValueSelector, reduxForm } from 'redux-form';
import { setSliderIndex } from 'src/actions/form';
import { getMenuItemsByArray, scrollToAnchor } from 'src/utils/helpers';
import {
    asyncCheckDuplicate,
    renderCheckbox,
    renderInput,
    renderSelectField,
} from 'src/components/misc/redux-form-helpers';
import {
    Entities,
    getCurrencySymbol,
    isInteger,
    isIntegerPercent,
    isMoneyAmount,
    isTwoDecimalPlaces,
    TOMCAT_URL,
    validatePrice,
} from 'src/common/index';
import { isBlank } from 'src/components/misc/validations';
import { connect } from 'react-redux';
import CustomTooltip from 'src/components/misc/CustomTooltip';

class CalculationEditForm extends Component {
    constructor(props) {
        super(props);
        autoBind(this);
    }

    componentWillMount() {
        this.props.setSliderIndex(0);
    }

    render() {
        const {
            handleSubmit,
            selectedSliderIndex,
            seasonCalculations,
            countryCalculations,
            arrivalReturnFlatRateCalculation,
            calculationSkipAvailabilityCheck,
            occupancySurcharges,
            forbidSecondDriver,
            specialVehicle,
            standingFeePerDay,
            priceRoundingMode,
            onlyForDailyTrips,
            minDriverPaymentHours,
            minBusPaymentHours,
            calculation,
            t,
        } = this.props;

        const seasonCalculationsMenuItems = getMenuItemsByArray(seasonCalculations.items, 'name');
        const countryCalculationsMenuItems = getMenuItemsByArray(countryCalculations.items, 'name');
        const currencySymbol = getCurrencySymbol(calculation.kilometreRate.currency);

        const ceilMinutesMenuItems = [
            { value: 1, label: '-' },
            { value: 15, label: '15 m' },
            { value: 30, label: '30 m' },
            { value: 60, label: '1 h' },
            { value: 120, label: '2 h' },
            { value: 180, label: '3 h' },
            { value: 720, label: '3/6/12 h' },
        ];

        return (
            <form className="form-horizontal" onSubmit={handleSubmit}>
                <div>
                    <Tabs onChange={value => this.props.setSliderIndex(value)} value={selectedSliderIndex}>
                        <Tab label={t('common_phrases.common')} value={0} />
                        <Tab label={t('calculation.km')} value={1} />
                        <Tab label={t('calculation.operating_hour_rates')} value={2} />
                        <Tab label={t('calculation.standing_hour_rates')} value={3} />
                        <Tab label={t('calculation.flatRates')} value={4} />
                        {occupancySurcharges && <Tab label={t('calculation.occupancySurcharges')} value={5} />}
                    </Tabs>
                    <SwipeableViews
                        index={selectedSliderIndex}
                        onChangeIndex={value => this.props.setSliderIndex(value)}>
                        {/* "Allgemein" tab */}
                        <div className="view">
                            <div id="topSection" className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="name"
                                        label={`${t('common_phrases.name')} *`}
                                        component={renderInput}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="seasonCalculation"
                                        label={`${t('calculation.season_calculation')} *`}
                                        component={renderSelectField}>
                                        {seasonCalculationsMenuItems}
                                    </Field>
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        name="countryCalculation"
                                        label={`${t('calculation.country_calculation')} *`}
                                        component={renderSelectField}>
                                        {countryCalculationsMenuItems}
                                    </Field>
                                </div>
                            </div>
                            <br />
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="priceRoundingMode"
                                        label={`${t('calculation.priceRoundingMode')} *`}
                                        component={renderSelectField}>
                                        {['UNNECESSARY', 'UP', 'DOWN', 'HALF_UP'].map(i => (
                                            <MenuItem key={i} value={i} primaryText={t('roundingMode.' + i)} />
                                        ))}
                                    </Field>
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        name="priceRoundingScale"
                                        label={`${t('calculation.priceRoundingScale')} *`}
                                        component={renderSelectField}
                                        disabled={priceRoundingMode == null || priceRoundingMode === 'UNNECESSARY'}>
                                        {[0, 1, 2].map(i => (
                                            <MenuItem key={i} value={-i} primaryText={10 ** i} />
                                        ))}
                                    </Field>
                                </div>
                            </div>
                            <br />
                            <div className="row voffset">
                                <div className="col-md-12">
                                    <Field
                                        name="forbidSecondDriver"
                                        label={t('calculation.forbidSecondDriver')}
                                        component={renderCheckbox}
                                    />
                                    <CustomTooltip
                                        id="forbidSecondDriver"
                                        text={t('calculation.forbidSecondDriver_info')}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="secondDriverStandingRateFactor"
                                        label={`${t('calculation.secondDriverStandingRateFactor')} *`}
                                        component={renderInput}
                                        disabled={forbidSecondDriver}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        name="secondDriverOperatingRateFactor"
                                        label={`${t('calculation.secondDriverOperatingRateFactor')} *`}
                                        component={renderInput}
                                        disabled={forbidSecondDriver}
                                    />
                                </div>
                            </div>
                            <br />
                            <div className="row voffset">
                                <div className="col-md-6">
                                    <Field
                                        name="specialVehicle"
                                        label={t('calculation.specialVehicle')}
                                        component={renderCheckbox}
                                    />
                                    <CustomTooltip id="specialVehicle" text={t('calculation.specialVehicle_info')} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="specialVehicleMaxKilometres"
                                        label={t('calculation.specialVehicleMaxKilometres')}
                                        component={renderInput}
                                        disabled={!specialVehicle}
                                        unit="km"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        name="specialVehicleMaxHours"
                                        label={t('calculation.specialVehicleMaxHours')}
                                        component={renderInput}
                                        disabled={!specialVehicle}
                                        unit="h"
                                    />
                                </div>
                            </div>
                            {calculationSkipAvailabilityCheck && (
                                <div className="row voffset">
                                    <div className="col-md-6">
                                        <Field
                                            name="skipAvailabilityCheck"
                                            label={t('calculation.skipAvailabilityCheck')}
                                            component={renderCheckbox}
                                        />
                                        <CustomTooltip
                                            id="skipAvailabilityCheck"
                                            text={t('calculation.skipAvailabilityCheck_info')}
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        {/* "Kilometer" tab */}
                        <div className="view">
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="kilometreRate.amount"
                                        label={`${t('calculation.km_rate')} *`}
                                        component={renderInput}
                                        unit={`${currencySymbol}/km`}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        name="extraKilometreRate.amount"
                                        label={`${t('calculation.extraKilometreRate')} *`}
                                        component={renderInput}
                                        unit={`${currencySymbol}/km`}
                                    />
                                    <CustomTooltip
                                        id="extraKilometreRate"
                                        text={t('calculation.extraKilometreRate_info')}
                                    />
                                </div>
                            </div>
                            {arrivalReturnFlatRateCalculation && (
                                <>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <Field
                                                name="arrivalReturnFlatRate.amount"
                                                label={`${t('calculation.arrivalReturnFlatRate')} *`}
                                                component={renderInput}
                                                unit={currencySymbol}
                                            />
                                            <CustomTooltip
                                                id="calculation.arrivalReturnFlatRateCalculation_info"
                                                text={t('calculation.arrivalReturnFlatRateCalculation_info')}
                                                place="left"
                                            />
                                        </div>
                                    </div>
                                    <br />
                                </>
                            )}
                            <br />
                            <h4>
                                {t('calculation.arrivalFees')}
                                <CustomTooltip id="arrivalFees" text={t('calculation.arrivalFees_info')} />
                            </h4>
                            <FieldArray
                                name="arrivalFees"
                                t={t}
                                currencySymbol={currencySymbol}
                                component={renderKilometreFees}
                            />
                            <br />
                            <h4>
                                {t('calculation.travelFees')}
                                <CustomTooltip id="travelFees" text={t('calculation.travelFees_info')} />
                            </h4>
                            <FieldArray
                                name="travelFees"
                                t={t}
                                currencySymbol={currencySymbol}
                                component={renderKilometreFees}
                            />
                        </div>
                        {/* "Stunden" tab */}
                        <div className="view">
                            <h4>{t('calculation.breaks')}</h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="arrivalBreakFee.amount"
                                        label={`${t('calculation.arrivalBreakFee')} *`}
                                        component={renderInput}
                                        unit={currencySymbol}
                                    />
                                    <CustomTooltip id="arrivalBreakFee" text={t('calculation.arrivalBreakFee_info')} />
                                </div>
                                <div className="col-md-6">
                                    <Field
                                        name="returnBreakFee.amount"
                                        label={`${t('calculation.returnBreakFee')} *`}
                                        component={renderInput}
                                        unit={currencySymbol}
                                    />
                                    <CustomTooltip id="returnBreakFee" text={t('calculation.returnBreakFee_info')} />
                                </div>
                            </div>
                            <br />
                            <h4>{t('calculation.driver_rate')}</h4>
                            <div className="row">
                                <div className="col-md-4">
                                    <Field
                                        name="driverRate.amount"
                                        label={`${t('calculation.driver_rate')} *`}
                                        component={renderInput}
                                        unit={`${currencySymbol}/h`}
                                    />
                                </div>
                                <div className="col-md-4">
                                    <Field
                                        name="extraHourRate.amount"
                                        label={`${t('calculation.extraHourRate')} *`}
                                        component={renderInput}
                                        unit={`${currencySymbol}/h`}
                                    />
                                    <CustomTooltip id="extraHourRate" text={t('calculation.extraHourRate_info')} />
                                </div>
                                <div className="col-md-4">
                                    <Field
                                        name="driverCeilMinutes"
                                        label={`${t('calculation.driverCeilMinutes')} *`}
                                        component={renderSelectField}>
                                        {ceilMinutesMenuItems.map(({ value, label }) => (
                                            <MenuItem
                                                key={`driverCeilMinutes-${value}`}
                                                value={value}
                                                primaryText={label}
                                            />
                                        ))}
                                    </Field>
                                </div>
                            </div>
                            <FieldArray name="operatingHourRates" t={t} component={renderOperatingHourRates} />
                            <br />
                            <h4>{t('calculation.busRate')}</h4>
                            <div className="row">
                                <div className="col-md-4">
                                    <Field
                                        name="busRate.amount"
                                        label={`${t('calculation.busRate')} *`}
                                        component={renderInput}
                                        unit={`${currencySymbol}/h`}
                                    />
                                    <CustomTooltip id="busRate" text={t('calculation.busRate_info')} />
                                </div>
                                <div className="col-md-4" />
                                <div className="col-md-4">
                                    <Field
                                        name="busCeilMinutes"
                                        label={`${t('calculation.busCeilMinutes')} *`}
                                        component={renderSelectField}>
                                        {ceilMinutesMenuItems.map(({ value, label }) => (
                                            <MenuItem
                                                key={`busCeilMinutes-${value}`}
                                                value={value}
                                                primaryText={label}
                                            />
                                        ))}
                                    </Field>
                                </div>
                            </div>
                            <FieldArray name="busOperatingHourRates" t={t} component={renderOperatingHourRates} />
                        </div>
                        {/* "Mehrtage" tab */}
                        <div className="view">
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="driverRoomPrice.amount"
                                        label={`${t('calculation.driver_room_price')} *`}
                                        component={renderInput}
                                        unit={currencySymbol}
                                    />
                                </div>
                                <div className="col-md-6 voffset">
                                    <Field
                                        name="onlyForDailyTrips"
                                        label={t('calculation.onlyForDailyTrips')}
                                        component={renderCheckbox}
                                    />
                                    <CustomTooltip
                                        id="onlyForDailyTrips"
                                        text={t('calculation.onlyForDailyTrips_info')}
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="standingFeePerDay.amount"
                                        label={t('calculation.standingFeePerDay')}
                                        component={renderInput}
                                        disabled={onlyForDailyTrips}
                                        unit={currencySymbol}
                                        floatingLabelFixed
                                    />
                                    <CustomTooltip
                                        id="standingFeePerDay"
                                        text={t('calculation.standingFeePerDay_info')}
                                    />
                                </div>
                            </div>

                            <br />
                            <h4>{t('calculation.standingHourRates')}</h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="minDriverPaymentHours"
                                        label={t('calculation.minDriverPaymentHours')}
                                        component={renderInput}
                                        disabled={onlyForDailyTrips}
                                        unit="h"
                                        floatingLabelFixed
                                    />
                                    <CustomTooltip
                                        id="minDriverPaymentHours"
                                        text={t('calculation.minDriverPaymentHours_info')}
                                    />
                                </div>
                                <div className="col-md-6 voffset">
                                    <Field
                                        name="noStandingHourRateForMultiDayTrips"
                                        label={t('calculation.noStandingHourRateForMultiDayTrips')}
                                        component={renderCheckbox}
                                        disabled={onlyForDailyTrips || !minDriverPaymentHours}
                                    />
                                    <CustomTooltip
                                        id="noStandingHourRateForMultiDayTrips"
                                        text={t('calculation.noStandingHourRateForMultiDayTrips_info')}
                                    />
                                </div>
                            </div>
                            <FieldArray
                                name="standingHourRates"
                                t={t}
                                currencySymbol={currencySymbol}
                                component={renderStandingHourRates}
                            />

                            <br />
                            <h4>{t('calculation.busStandingHourRates')}</h4>
                            <div className="row">
                                <div className="col-md-6">
                                    <Field
                                        name="minBusPaymentHours"
                                        label={t('calculation.minBusPaymentHours')}
                                        component={renderInput}
                                        disabled={onlyForDailyTrips}
                                        unit="h"
                                        floatingLabelFixed
                                    />
                                    <CustomTooltip
                                        id="minBusPaymentHours"
                                        text={t('calculation.minBusPaymentHours_info')}
                                    />
                                </div>
                                <div className="col-md-6 voffset">
                                    <Field
                                        name="noBusStandingHourRateForMultiDayTrips"
                                        label={t('calculation.noBusStandingHourRateForMultiDayTrips')}
                                        component={renderCheckbox}
                                        disabled={onlyForDailyTrips || !minDriverPaymentHours}
                                    />
                                    <CustomTooltip
                                        id="noBusStandingHourRateForMultiDayTrips"
                                        text={t('calculation.noBusStandingHourRateForMultiDayTrips_info')}
                                    />
                                </div>
                            </div>
                            <FieldArray
                                name="busStandingHourRates"
                                t={t}
                                currencySymbol={currencySymbol}
                                component={renderStandingHourRates}
                            />
                        </div>
                        {/* "Pauschalen" tab */}
                        <div className="view">
                            <FieldArray
                                name="flatRates"
                                t={t}
                                currencySymbol={currencySymbol}
                                component={renderFlatRates}
                            />
                        </div>
                        {/* "Auslastung" tab */}
                        <div className="view">
                            <h4>
                                {t('calculation.occupancySurcharges')}
                                <CustomTooltip
                                    id="occupancySurcharges"
                                    text={t('calculation.occupancySurcharges_info')}
                                />
                            </h4>
                            {(occupancySurcharges && (
                                <FieldArray name="occupancySurcharges" t={t} component={renderOccupancySurcharges} />
                            )) || <div>{t('common_phrases.module_deactivated')}</div>}
                            <br />
                            <h4>
                                {t('calculation.globalOccupancySurcharges')}
                                <CustomTooltip
                                    id="globalOccupancySurcharges"
                                    text={t('calculation.globalOccupancySurcharges_info')}
                                />
                            </h4>
                            {(occupancySurcharges && (
                                <FieldArray
                                    name="globalOccupancySurcharges"
                                    t={t}
                                    component={renderOccupancySurcharges}
                                />
                            )) || <div>{t('common_phrases.module_deactivated')}</div>}
                        </div>
                    </SwipeableViews>
                </div>
            </form>
        );
    }
}

const renderKilometreFees = ({ fields, t, currencySymbol, tooltip }) => (
    <>
        <div className="row" style={{ margin: 0 }}>
            <div className="col-md-6">
                <div className="form-group">
                    <RaisedButton
                        secondary={true}
                        label={`+ ${t('calculation.new_rate')}`}
                        onClick={() =>
                            fields.push({
                                toKilometre: 0,
                                price: 0,
                            })
                        }
                    />
                </div>
            </div>
        </div>

        {fields.map((arrivalFee, index) => (
            <div key={index} className="row" style={{ margin: 0 }}>
                <div className="col-md-6">
                    <div className="form-group">
                        <Field
                            name={`${arrivalFee}.toKilometre`}
                            label={`${t('calculation.to_km')} *`}
                            component={renderInput}
                            type="number"
                            unit="km"
                        />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="form-group">
                        <Field
                            name={`${arrivalFee}.price.amount`}
                            label={`${t('calculation.km_rate')} *`}
                            component={renderInput}
                            unit={`${currencySymbol}/km`}
                        />
                    </div>
                </div>
                <div className="col-md-1 voffset">
                    <button className="btn btn-sm" type="button" onClick={() => fields.remove(index)}>
                        <span className="glyphicon glyphicon-trash" />
                    </button>
                </div>
            </div>
        ))}
    </>
);

const renderStandingHourRates = ({ fields, t, currencySymbol }) => (
    <>
        <div className="row" style={{ margin: 0 }}>
            <div className="col-md-6">
                <div className="form-group">
                    <RaisedButton
                        secondary={true}
                        label={`+ ${t('calculation.new_rate')}`}
                        onClick={() =>
                            fields.push({
                                fromHours: 0,
                                rate: 0,
                            })
                        }
                    />
                </div>
            </div>
        </div>

        {fields.map((field, index) => (
            <div key={index} className="row" style={{ margin: 0 }}>
                <div className="col-md-6">
                    <div className="form-group">
                        <Field
                            name={`${field}.fromHours`}
                            label={`${t('calculation.from_hours')} *`}
                            step="1"
                            component={renderInput}
                            type="number"
                            unit="h"
                        />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="form-group">
                        <Field
                            name={`${field}.rate.amount`}
                            label={`${t('calculation.rate_price')} *`}
                            component={renderInput}
                            unit={`${currencySymbol}/h`}
                        />
                    </div>
                </div>
                <div className="col-md-1 voffset">
                    <button className="btn btn-sm" type="button" onClick={() => fields.remove(index)}>
                        <span className="glyphicon glyphicon-trash" />
                    </button>
                </div>
            </div>
        ))}
    </>
);

const renderOperatingHourRates = ({ fields, t }) => (
    <>
        <div className="row" style={{ margin: 0 }}>
            <div className="col-md-6">
                <div className="form-group">
                    <RaisedButton
                        secondary={true}
                        label={`+ ${t('calculation.new_rate')}`}
                        onClick={() =>
                            fields.push({
                                fromHours: 0,
                                rate: 0,
                            })
                        }
                    />
                </div>
            </div>
        </div>

        {fields.map((field, index) => (
            <div key={index} className="row" style={{ margin: 0 }}>
                <div className="col-md-6">
                    <div className="form-group">
                        <Field
                            name={`${field}.fromHours`}
                            label={`${t('calculation.from_hours')} *`}
                            step="1"
                            component={renderInput}
                            type="number"
                        />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="form-group">
                        <Field
                            name={`${field}.rate.amount`}
                            label={`${t('calculation.rate_price')} *`}
                            component={renderInput}
                        />
                    </div>
                </div>
                <div className="col-md-1 voffset">
                    <button className="btn btn-sm" type="button" onClick={() => fields.remove(index)}>
                        <span className="glyphicon glyphicon-trash" />
                    </button>
                </div>
            </div>
        ))}
    </>
);

const renderFlatRates = ({ fields, flatRates = [], t, currencySymbol }) => (
    <>
        <div className="row voffset">
            <div className="col-md-6">
                <Field name="onlyForFlatRates" label={t('calculation.onlyForFlatRates')} component={renderCheckbox} />
                <CustomTooltip id="onlyForFlatRates" text={t('calculation.onlyForFlatRates_info')} />
            </div>
            <div className="col-md-6">
                <Field
                    name="seasonSurchargesForFlatRates"
                    label={t('calculation.seasonSurchargesForFlatRates')}
                    component={renderCheckbox}
                />
                <CustomTooltip
                    id="seasonSurchargesForFlatRates"
                    text={t('calculation.seasonSurchargesForFlatRates_info')}
                />
            </div>
        </div>
        <br />
        <h4>
            {t('calculation.flatRates')}
            <CustomTooltip id="flatRates" text={t('calculation.flatRates_info')} />
        </h4>
        <div className="row voffset" style={{ margin: 0 }}>
            <div className="col-md-6">
                <div className="form-group">
                    <RaisedButton
                        secondary={true}
                        label={`+ ${t('calculation.new_flat_rate')}`}
                        onClick={() =>
                            fields.push({
                                maxHours: 0,
                                maxKilometres: 0,
                            })
                        }
                    />
                </div>
            </div>
        </div>

        {fields.map((flatRate, index) => (
            <FlatRateRowWithValues
                key={flatRate}
                flatRate={flatRate}
                index={index}
                fields={fields}
                t={t}
                currencySymbol={currencySymbol}
            />
        ))}
    </>
);

const FlatRateRow = ({
    flatRate,
    index,
    fields,
    t,
    minCalculatedHours,
    minCalculatedKilometres,
    price,
    currencySymbol,
}) => {
    const disablePrice = !!minCalculatedHours || !!minCalculatedKilometres;
    const disableMins = price != null && !!price.amount;

    return (
        <div key={index} style={{ margin: 0 }}>
            <div className="row">
                <div className="col-md-3">
                    <Field
                        name={`${flatRate}.maxHours`}
                        label={`${t('calculation.flat_rate.maxHours')} *`}
                        component={renderInput}
                        unit="h"
                    />
                </div>
                <div className="col-md-3">
                    <Field
                        name={`${flatRate}.maxKilometres`}
                        label={`${t('calculation.flat_rate.maxKilometres')} *`}
                        component={renderInput}
                        unit="km"
                    />
                </div>
                <div className="col-md-5 voffset">
                    <Field
                        name={`${flatRate}.perStage`}
                        label={`${t('calculation.flat_rate.perStage')}`}
                        component={renderCheckbox}
                    />
                    <CustomTooltip id={`${flatRate}.perStage`} text={t('calculation.flat_rate.perStage_info')} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <Field
                        name={`${flatRate}.minCalculatedHours`}
                        label={`${t('calculation.flat_rate.minCalculatedHours')} *`}
                        component={renderInput}
                        disabled={disableMins}
                        unit="h"
                        floatingLabelFixed
                    />
                </div>
                <div className="col-md-3">
                    <Field
                        name={`${flatRate}.minCalculatedKilometres`}
                        label={`${t('calculation.flat_rate.minCalculatedKilometres')} *`}
                        component={renderInput}
                        disabled={disableMins}
                        unit="km"
                        floatingLabelFixed
                    />
                </div>
                <div className="col-md-5">
                    <Field
                        name={`${flatRate}.price.amount`}
                        label={`${t('calculation.flat_rate.price')} *`}
                        component={renderInput}
                        disabled={disablePrice}
                        unit={currencySymbol}
                        floatingLabelFixed
                    />
                </div>
                <div className="col-md-1 voffset">
                    <button className="btn btn-sm" type="button" onClick={() => fields.remove(index)}>
                        <span className="glyphicon glyphicon-trash" />
                    </button>
                </div>
            </div>
        </div>
    );
};

const FlatRateRowWithValues = formValues(props => ({
    minCalculatedHours: `${props.flatRate}.minCalculatedHours`,
    minCalculatedKilometres: `${props.flatRate}.minCalculatedKilometres`,
    price: `${props.flatRate}.price`,
}))(FlatRateRow);

const renderOccupancySurcharges = ({ fields, t }) => (
    <>
        <div className="row" style={{ margin: 0 }}>
            <div className="col-md-6">
                <div className="form-group">
                    <RaisedButton
                        secondary={true}
                        label={`+ ${t('calculation.occupancy_surcharges')}`}
                        onClick={() =>
                            fields.push({
                                occupancy: 0,
                                surcharge: 0,
                            })
                        }
                    />
                </div>
            </div>
        </div>

        {fields.map((occupancy, index) => (
            <div key={index} className="row" style={{ margin: 0 }}>
                <div className="col-md-6">
                    <div className="form-group">
                        <Field
                            name={`${occupancy}.occupancy`}
                            label={`${t('calculation.from_capacity')} *`}
                            component={renderInput}
                            type="number"
                            unit="%"
                        />
                    </div>
                </div>
                <div className="col-md-5">
                    <div className="form-group">
                        <Field
                            name={`${occupancy}.surcharge`}
                            label={`${t('calculation.surcharge')} *`}
                            component={renderInput}
                            type="number"
                            unit="%"
                        />
                    </div>
                </div>
                <div className="col-md-1 voffset">
                    <button className="btn btn-sm" type="button" onClick={() => fields.remove(index)}>
                        <span className="glyphicon glyphicon-trash" />
                    </button>
                </div>
            </div>
        ))}
    </>
);

const validate = (values, props) => {
    const { t } = props;
    const errors = {
        kilometreRate: {
            amount: undefined,
        },
        driverRate: {
            amount: undefined,
        },
        busRate: {
            amount: undefined,
        },
        driverRoomPrice: {
            amount: undefined,
        },
        extraHourRate: {
            amount: undefined,
        },
        extraKilometreRate: {
            amount: undefined,
        },
        arrivalBreakFee: {
            amount: undefined,
        },
        returnBreakFee: {
            amount: undefined,
        },
        arrivalReturnFlatRate: {
            amount: undefined,
        },
        standingFeePerDay: {
            amount: undefined,
        },
    };

    if (isBlank(values.name)) errors.name = t('error_missing.fill_in_name');

    if (!values.seasonCalculation) errors.seasonCalculation = t('calculation.fill_in_special_rate');

    if (!values.countryCalculation) errors.countryCalculation = t('calculation.fill_in_country_rate');

    if (!isMoneyAmount(values.kilometreRate)) errors.kilometreRate.amount = t('calculation.fill_in_km_rate');
    else if (validatePrice(values.kilometreRate.amount))
        errors.kilometreRate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.driverRate)) errors.driverRate.amount = t('calculation.fill_in_rate');
    else if (validatePrice(values.driverRate.amount))
        errors.driverRate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.busRate)) errors.busRate.amount = t('calculation.fill_in_rate');
    else if (validatePrice(values.busRate.amount))
        errors.busRate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.driverRoomPrice)) errors.driverRoomPrice.amount = t('calculation.fill_in_hour_rate');
    else if (validatePrice(values.driverRoomPrice.amount))
        errors.driverRoomPrice.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (values.secondDriverStandingRateFactor == null)
        errors.secondDriverStandingRateFactor = t('calculation.fill_in_rate');
    else if (validatePrice(values.secondDriverStandingRateFactor))
        errors.secondDriverStandingRateFactor = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (values.secondDriverOperatingRateFactor == null)
        errors.secondDriverOperatingRateFactor = t('calculation.fill_in_rate');
    else if (validatePrice(values.secondDriverOperatingRateFactor))
        errors.secondDriverOperatingRateFactor = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.extraHourRate)) errors.extraHourRate.amount = t('calculation.fill_in_additional_hour');
    else if (validatePrice(values.extraHourRate.amount))
        errors.extraHourRate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.extraKilometreRate))
        errors.extraKilometreRate.amount = t('calculation.fill_in_additional_km');
    else if (validatePrice(values.extraKilometreRate.amount))
        errors.extraKilometreRate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.arrivalBreakFee)) errors.arrivalBreakFee.amount = t('calculation.fill_in_surcharge');
    else if (validatePrice(values.arrivalBreakFee.amount))
        errors.arrivalBreakFee.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.returnBreakFee)) errors.returnBreakFee.amount = t('calculation.fill_in_surcharge');
    else if (validatePrice(values.returnBreakFee.amount))
        errors.returnBreakFee.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (!isMoneyAmount(values.arrivalReturnFlatRate))
        errors.arrivalReturnFlatRate.amount = t('calculation.fill_in_rate_flat_rate');
    else if (validatePrice(values.arrivalReturnFlatRate.amount))
        errors.arrivalReturnFlatRate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (
        values.minDriverPaymentHours &&
        (!isTwoDecimalPlaces(values.minDriverPaymentHours) || values.minDriverPaymentHours <= 0)
    ) {
        errors.minDriverPaymentHours = t('calculation.fill_in_h');
    }

    if (
        values.minBusPaymentHours &&
        (!isTwoDecimalPlaces(values.minBusPaymentHours) || values.minBusPaymentHours <= 0)
    ) {
        errors.minBusPaymentHours = t('calculation.fill_in_h');
    }

    if (
        values.specialVehicleMaxKilometres &&
        (!isInteger(values.specialVehicleMaxKilometres) || values.specialVehicleMaxKilometres < 0)
    ) {
        errors.specialVehicleMaxKilometres = t('calculation.fill_in_km');
    }

    if (
        values.specialVehicleMaxHours &&
        (!isTwoDecimalPlaces(values.specialVehicleMaxHours) || values.specialVehicleMaxHours < 0)
    ) {
        errors.specialVehicleMaxHours = t('calculation.fill_in_h');
    }

    if (isMoneyAmount(values.standingFeePerDay) && validatePrice(values.standingFeePerDay.amount))
        errors.standingFeePerDay.amount = `${t('error_hint.error_invalid_format')} (######.00)`;

    if (values.arrivalFees) errors.arrivalFees = validateKilometreFees(t, values.arrivalFees, 70);

    if (values.travelFees) errors.travelFees = validateKilometreFees(t, values.travelFees, 10000);

    if (values.standingHourRates) errors.standingHourRates = validateHourRates(t, values.standingHourRates);

    if (values.operatingHourRates) errors.operatingHourRates = validateHourRates(t, values.operatingHourRates);

    if (values.busStandingHourRates) errors.busStandingHourRates = validateHourRates(t, values.busStandingHourRates);

    if (values.busOperatingHourRates) errors.busOperatingHourRates = validateHourRates(t, values.busOperatingHourRates);

    if (values.flatRates) errors.flatRates = validateFlatRates(t, values.flatRates);

    if (values.occupancySurcharges)
        errors.occupancySurcharges = validateOccupancySurcharges(t, false, values.occupancySurcharges);

    if (values.globalOccupancySurcharges)
        errors.globalOccupancySurcharges = validateOccupancySurcharges(t, true, values.globalOccupancySurcharges);

    return errors;
};

const validateKilometreFees = (t, kilometreFees, max) => {
    const errors = [];
    const seen = new Set();

    kilometreFees.forEach((kilometreFee, index) => {
        const error = {
            toKilometre: undefined,
            price: {
                amount: undefined,
            },
        };

        if (!kilometreFee.toKilometre || kilometreFee.toKilometre < 1) {
            error.toKilometre = t('error_hint.error_min', { min: 1 });
            errors[index] = error;
        } else if (kilometreFee.toKilometre > max) {
            error.toKilometre = t('error_hint.error_max', { max: max });
            errors[index] = error;
        } else if (!isInteger(kilometreFee.toKilometre)) {
            error.toKilometre = t('error_hint.error_integer');
            errors[index] = error;
        } else if (seen.has(kilometreFee.toKilometre)) {
            error.toKilometre = t('error_hint.error_unique');
            errors[index] = error;
        }

        if (!isMoneyAmount(kilometreFee.price)) {
            error.price.amount = t('calculation.fill_in_km_rate');
            errors[index] = error;
        } else if (validatePrice(kilometreFee.price.amount)) {
            error.price.amount = `${t('error_hint.error_invalid_format')} (######.00)`;
            errors[index] = error;
        }

        seen.add(kilometreFee.toKilometre);
    });

    if (errors.length > 0) return errors;
};

const validateHourRates = (t, hourRates) => {
    const errors = [];
    const seen = new Set();
    hourRates.forEach((hourRate, index) => {
        const error = {
            fromHours: undefined,
            rate: {
                amount: undefined,
            },
        };

        if (!isInteger(hourRate.fromHours)) {
            error.fromHours = t('error_hint.error_integer');
            errors[index] = error;
        } else if (hourRate.fromHours < 0) {
            error.fromHours = t('error_hint.error_negative');
            errors[index] = error;
        } else if (hourRate.fromHours > 100) {
            error.fromHours = t('error_hint.error_max', { max: 100 });
            errors[index] = error;
        } else if (seen.has(hourRate.fromHours)) {
            error.fromHours = t('error_hint.error_unique');
            errors[index] = error;
        }

        if (!isMoneyAmount(hourRate.rate)) {
            error.rate.amount = t('calculation.fill_in_rate');
            errors[index] = error;
        } else if (validatePrice(hourRate.rate.amount)) {
            error.rate.amount = `${t('error_hint.error_invalid_format')} (######.00)`;
            errors[index] = error;
        }

        seen.add(hourRate.fromHours);
    });

    if (errors.length > 0) return errors;
};

const validateFlatRates = (t, flatRates) => {
    const errors = [];
    const seen = new Set();
    flatRates.forEach((flatRate, index) => {
        const error = {
            maxHours: undefined,
            price: {
                amount: undefined,
            },
        };

        if (!isInteger(flatRate.maxHours)) {
            error.maxHours = t('error_hint.error_integer');
            errors[index] = error;
        } else if (flatRate.maxHours <= 0) {
            error.maxHours = t('error_hint.notNegativeOrZero');
            errors[index] = error;
        } else if (flatRate.maxHours > 100) {
            error.maxHours = t('error_hint.error_max', { max: 100 });
            errors[index] = error;
        }

        if (!isInteger(flatRate.maxKilometres)) {
            error.maxKilometres = t('error_hint.error_integer');
            errors[index] = error;
        } else if (flatRate.maxKilometres <= 0) {
            error.maxKilometres = t('error_hint.notNegativeOrZero');
            errors[index] = error;
        } else if (flatRate.maxKilometres > 10000) {
            error.maxKilometres = t('error_hint.error_max', { max: 10000 });
            errors[index] = error;
        }

        if (seen.has(`${flatRate.maxHours}|${flatRate.maxKilometres}`)) {
            error.maxHours = t('error_hint.error_unique');
            error.maxKilometres = t('error_hint.error_unique');
            errors[index] = error;
        }

        if (flatRate.minCalculatedHours)
            if (!isInteger(flatRate.minCalculatedHours)) {
                error.minCalculatedHours = t('error_hint.error_integer');
                errors[index] = error;
            } else if (flatRate.minCalculatedHours < 1) {
                error.minCalculatedHours = t('error_hint.notNegativeOrZero');
                errors[index] = error;
            } else if (flatRate.minCalculatedHours > 100) {
                error.minCalculatedHours = t('error_hint.error_max', { max: 100 });
                errors[index] = error;
            }

        if (flatRate.minCalculatedKilometres)
            if (!isInteger(flatRate.minCalculatedKilometres)) {
                error.minCalculatedKilometres = t('error_hint.error_integer');
                errors[index] = error;
            } else if (flatRate.minCalculatedKilometres < 1) {
                error.minCalculatedKilometres = t('error_hint.notNegativeOrZero');
                errors[index] = error;
            } else if (flatRate.minCalculatedKilometres > 10000) {
                error.minCalculatedKilometres = t('error_hint.error_max', { max: 10000 });
                errors[index] = error;
            }

        if (flatRate.price && flatRate.price.amount)
            if (!isMoneyAmount(flatRate.price)) {
                error.price.amount = t('error_missing.fill_in');
                errors[index] = error;
            } else if (validatePrice(flatRate.price.amount)) {
                error.price.amount = `${t('error_hint.error_invalid_format')} (######.00)`;
                errors[index] = error;
            } else if (flatRate.price.amount <= 0) {
                error.price.amount = t('error_hint.notNegativeOrZero');
                errors[index] = error;
            }

        if (flatRate.minCalculatedHours && !flatRate.minCalculatedKilometres) {
            error.minCalculatedKilometres = t('error_missing.fill_in');
            errors[index] = error;
        }

        if (!flatRate.minCalculatedHours && flatRate.minCalculatedKilometres) {
            error.minCalculatedHours = t('error_missing.fill_in');
            errors[index] = error;
        }

        if (
            !flatRate.minCalculatedHours &&
            !flatRate.minCalculatedKilometres &&
            (!flatRate.price || !flatRate.price.amount)
        ) {
            error.minCalculatedHours = t('error_missing.fill_in');
            error.minCalculatedKilometres = t('error_missing.fill_in');
            error.price.amount = t('error_missing.fill_in');
            errors[index] = error;
        }

        seen.add(`${flatRate.maxHours}|${flatRate.maxKilometres}`);
    });

    if (errors.length > 0) return errors;
};

const validateOccupancySurcharges = (t, global, surcharges) => {
    const errors = [];
    const seen = new Set();
    surcharges.forEach((surcharge, index) => {
        const error = {
            occupancy: undefined,
            surcharge: undefined,
        };

        if (!surcharge.occupancy || !isInteger(surcharge.occupancy) || surcharge.occupancy <= 0) {
            error.occupancy = t('calculation.fill_in_capacity');
            errors[index] = error;
        } else if (seen.has(surcharge.occupancy)) {
            error.occupancy = t('error_hint.error_unique');
            errors[index] = error;
        }

        if (!surcharge.surcharge) {
            error.surcharge = t('calculation.fill_in_surcharge');
            errors[index] = error;
        } else if (!isIntegerPercent(surcharge.surcharge)) {
            error.surcharge = t('calculation.fill_in_surcharge_criteria');
            errors[index] = error;
        }
        // a positive surcharge is only allowed for global occupancy equal to or greater than 50 percent
        else if (global && surcharge.surcharge > 0 && surcharge.occupancy < 50) {
            error.surcharge = t('calculation.fill_in_occupancy_surcharge_criteria');
            errors[index] = error;
        }

        seen.add(surcharge.occupancy);
    });

    if (errors.length > 0) return errors;
};

const asyncValidate = (values, dispatch, props) => {
    return asyncCheckDuplicate(
        props.t,
        `${TOMCAT_URL}api/${Entities.CALCULATION.repository}/search/findByNameAndCompanyId?name=${encodeURIComponent(
            values.name,
        )}&companyId=${props.selectedCompany}`,
        values.id,
        'name',
    );
};

const onSubmitFail = (errors, dispatch) => {
    if (!errors) return;

    if (
        (errors.kilometreRate && errors.kilometreRate.amount) ||
        (errors.extraKilometreRate && errors.extraKilometreRate.amount) ||
        (errors.arrivalBreakFee && errors.arrivalBreakFee.amount) ||
        (errors.returnBreakFee && errors.returnBreakFee.amount) ||
        (errors.arrivalReturnFlatRate && errors.arrivalReturnFlatRate.amount) ||
        errors.arrivalFees ||
        errors.travelFees
    )
        dispatch(setSliderIndex(1));
    else if (
        (errors.driverRate && errors.driverRate.amount) ||
        (errors.extraHourRate && errors.extraHourRate.amount) ||
        (errors.busRate && errors.busRate.amount) ||
        errors.operatingHourRates ||
        errors.busOperatingHourRates
    )
        dispatch(setSliderIndex(2));
    else if (
        (errors.driverRoomPrice && errors.driverRoomPrice.amount) ||
        (errors.standingFeePerDay && errors.standingFeePerDay.amount) ||
        errors.minDriverPaymentHours ||
        errors.minBusPaymentHours ||
        errors.standingHourRates ||
        errors.busStandingHourRates
    )
        dispatch(setSliderIndex(3));
    else if (errors.flatRates) dispatch(setSliderIndex(4));
    else if (errors.occupancySurcharges || errors.globalOccupancySurcharges) dispatch(setSliderIndex(5));
    else {
        scrollToAnchor('topSection');
        dispatch(setSliderIndex(0));
    }
};

CalculationEditForm = reduxForm({
    form: 'calculationEditForm',
    onSubmitFail,
    validate,
    asyncValidate,
    asyncBlurFields: ['name'],
})(CalculationEditForm);

const selector = formValueSelector('calculationEditForm');
CalculationEditForm = connect(
    state => ({
        forbidSecondDriver: selector(state, 'forbidSecondDriver'),
        specialVehicle: selector(state, 'specialVehicle'),
        standingFeePerDay: selector(state, 'standingFeePerDay'),
        priceRoundingMode: selector(state, 'priceRoundingMode'),
        onlyForDailyTrips: selector(state, 'onlyForDailyTrips'),
        minDriverPaymentHours: selector(state, 'minDriverPaymentHours'),
        minBusPaymentHours: selector(state, 'minBusPaymentHours'),
    }),
    null,
    null,
    { withRef: true },
)(CalculationEditForm);

export default CalculationEditForm;
